<template>
  <div>
    <el-row class="cs-contentContainer">
      <el-col :span="4" class="cs-main-left-container">
        <navigator></navigator>
      </el-col>
      <el-col
        :span="20"
        class="backgroud-gray cs-fullHeight cs-main-right-container"
      >
        <div class="cs-fullHeight cs-contentContainer-right">
          <div
            class="
              backgroud-white
              cs-contentContainer-right-content cs-fullHeight
            "
          >
            <el-row>
              <el-col>
                <span class="cs-title">公开课</span>
                <el-row>
                  <el-col :span="5">
                    <el-input
                      placeholder="课程名"
                      size="medium"
                      clearable
                      suffix-icon="el-icon-search"
                      v-model.trim="searchCondition.Name"
                      @change="onSearchConditionChanged"
                    >
                    </el-input>
                  </el-col>
                  <el-col v-if="!isStudent" :span="6">
                    <el-select
                      multiple
                      placeholder="校区"
                      v-model="searchCondition.GroupNumbers"
                      @change="onSearchConditionChanged"
                      size="medium"
                      class="margin-left-20px"
                    >
                      <el-option
                        v-for="item in universityGroups"
                        :key="item.GroupNumber"
                        :label="item.NameValue"
                        :value="item.GroupNumber"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col :span="5">
                    <el-button
                      type="primary"
                      :disabled="loading"
                      size="medium"
                      class="margin-left-20px"
                      @click="onSearchClick"
                      >搜索</el-button
                    >
                    <el-button
                      v-if="!isStudent"
                      type="primary"
                      :disabled="loading"
                      class="margin-left-20px"
                      size="medium"
                      @click="onAddClick"
                      >添加</el-button>
                  </el-col>
                </el-row>
                <pagination
                  v-loading="loading"
                  :data="listData"
                  :option="paginationOption"
                  @loadData="onSearch"
                  @pageSizeChange="onPageSizeChange"
                  @currentPageChange="onCurrentPageChange"
                  @additional="onAdditional"
                ></pagination>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
    <a id="openCourseLink" style="display: none" target="_blank"></a>
    <el-dialog
      v-if="videoViewVisible"
      title="公开课视频回看"
      :center="true"
      :close-on-click-modal="false"
      :visible.sync="videoViewVisible"
      top="8vh"
      width="630px"
    >
      <div v-html="videoPath"></div>
    </el-dialog>
    <openCourseEditor :data="editorData" :visible="editorVisible" @close="onOpenCourseEditorClose" @change="onOpenCourseEditorChange" />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import navigator from "../components/navigator";
import pagination from "../components/common/pagination";
import openCourseEditor from "../components/openCourse/openCourseEditor";
import {
  getUniversityGroups,
  getOpenCoursePageList,
  removeOpenCourse
} from "../service/common.service";

export default {
  data() {
    return {
      paginationOption: {},
      universityGroups: [],
        //{ GroupNumber: 0, IdValue: "0", NameValue: "所有校区" },
      searchCondition: {
        GroupNumbers: [],
        name: "",
      },
      isStudent: this.USERMANAGER.isStudent,
      loading: false,
      pageSize: 20,
      listData: {},
      videoViewVisible: false,
      videoPath: "",
      editorVisible: false,
      editorData:{}
    };
  },
  components: {
    navigator,
    pagination,
    openCourseEditor
  },
  created() {
    this.loading = true;
    getUniversityGroups().then((result) => {
      if (!!result && result.success) {
        this.universityGroups = result.data;
        this.searchCondition.GroupNumbers = [];
        this.search();
      }
    });
    let columns = [
      { name: "Link", title: "直播间", buttonText: "进入直播间" },
      {
        name: "VideoPath",
        title: "课程回看",
        buttonText: "点击回看",
        fnType: this.getVideoPathStyle,
        fnDisabled: this.getVideoPathDisabled,
      },
    ];
    if (!this.isStudent) {
      columns.push({ name: "Edit", title: "", buttonText: "编辑" });
      columns.push({
        name: "Delete",
        title: "",
        buttonText: "删除",
        fnType: this.getDeleteStyle,
      });
    }
    this.paginationOption = {
      displayPagination: true,
      hasEditButton: false,
      hasAddButton: false,
      hasSearch: false,
      hasDeleteButton: false,
      isNotStudent: !this.USERMANAGER.isStudent,
      additionalColumns: columns,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    getVideoPathStyle(index, row) {
      if (!!row.VideoPath) {
        return "primary";
      } else {
        return "info";
      }
    },
    getVideoPathDisabled(index, row) {
      if (!!row.VideoPath) {
        return false;
      } else {
        return true;
      }
    },
    getDeleteStyle(index, row) {
      return "danger";
    },
    onSearchConditionChanged(name, isSearch) {},
    showEditor(row){
  
      if (!!row){
        this.editorData = {
          Id: row.Id,
          UniversityGroupNumber: row.UniversityGroupNumber,
          Name: row.Name,
          StartTime: row.StartTimeText,
          Link: row.Link,
          VideoPath: row.VideoPath,
        };
      }else{
        this.editorData = undefined;
      }
      this.editorVisible = true;
    },
    onAddClick(){
      this.showEditor();
    },
    onAdditional(name, index, row) {
      switch (name) {
        case "Link": {
          let link = row.Link;
          let a = document.getElementById("openCourseLink");
          a.setAttribute("href", link);
          a.click();
          break;
        }
        case "VideoPath": {
          if (!row.VideoPath) {
            this.$message.error("没有设置视频");
            return;
          }
          this.videoPath = row.VideoPath;
          this.videoViewVisible = true;
          break;
        }
        case "Edit": {
          this.showEditor(row);
          break;
        }
        case "Delete": {
          this.delete(row);
          break;
        }
      }
    },
    delete(row) {
      this.$confirm("您确认要删除该公开课吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          removeOpenCourse(row.Id).then((result) => {
            if (!!result && result.success) {
              this.$message.success("删除成功");
              this.search();
            }
          });
        })
        .catch(() => {});
    },
    search(pageData) {
      this.loading = true;
      let searchData = this.getSearchPageData(pageData);
      getOpenCoursePageList(searchData).then((result) => {
        if (!!result && result.success) {
          this.listData = result.data;
        }
        this.loading = false;
      });
    },
    onSearchClick() {
      this.search();
    },
    onSearch(pageData) {
      this.search(pageData);
    },
    onPageSizeChange(value) {
      this.pageSize = value;
    },
    onCurrentPageChange(value) {},
    getSearchPageData(pageData) {
   
      if (typeof pageData == "undefined" || pageData == 1) {
        pageData = {
          pageNumber: 1,
        };
      }
      let additionalFilter = {
        GroupNumbers: this.searchCondition.GroupNumbers,
      };

      let searchData = {
        pageSize: this.pageSize,
        keyWord: this.searchCondition.Name,
        startDate: "",
        endDate: "",
        additionalFilter: additionalFilter,
      };
      searchData = $.extend({}, pageData, searchData);
      return searchData;
    },

    onOpenCourseEditorClose() {
      this.editorVisible = false;
    },
    onOpenCourseEditorChange() {
      this.onOpenCourseEditorClose();
      this.search();
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/page/openCourseList.vue